import { NeoModel } from '@singularsystems/neo-core';
import { ReportingServiceBase } from '@singularsystems/neo-reporting';
import { IReportType } from '@singularsystems/neo-reporting/dist/Models/IReportType';
import { injectable } from 'inversify'
import ClientReportingService from '../ClientReports/ClientReportingService';
import MaintenanceReportingService from '../MaintenanceReports/MaintenanceReportingService';

@injectable()
@NeoModel
export default class NeoReportingService extends ReportingServiceBase {
    public clientReportService = new ClientReportingService();
    public maintenanceReportService = new MaintenanceReportingService();
    
    public getReports() {
        return [
            ...this.clientReportService.getReports(),
            ...this.maintenanceReportService.getReports()
        ] as unknown as IReportType[]
    }
}